import { Component, effect, inject, signal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { EhrService, Organisation } from '@beautyapp/core';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
  selector: 'beautyapp-activate-ehr',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    NzModalModule
  ],
  templateUrl: './activate-ehr.component.html',
  styleUrl: './activate-ehr.component.scss'
})
export class ActivateEhrComponent {

  store = inject(Store);
  modalRef = inject(NzModalRef);
  ehrService = inject(EhrService);

  clinicInfo = signal<any>(null);

  organization = this.store.selectSignal<Organisation>((state) => state.auth.user.organization);

  form: FormGroup = new FormGroup({
    password: new FormControl<string | null>(null, { nonNullable: true }),
    hospitalId: new FormControl<string | null>(null, { nonNullable: true }),
    ehrPrefix: new FormControl<string | null>(null, { nonNullable: true })
  });

  constructor() {
    effect(() => {
      if (this.clinicInfo()) {
        this.form.patchValue({
          hospitalId: this.clinicInfo().hospitalId,
          ehrPrefix: this.clinicInfo().ehrPrefix
        });
      }
    });
  }

  onSubmit() {
    this.form.markAllAsTouched();

    if (this.form.invalid) {
      console.error('Form is invalid:', this.form.errors);
      return;
    }

    if (this.clinicInfo()) {
      this.ehrService.updateClinicInfo({
        hospitalId: this.form.value.hospitalId,
        ehrPrefix: this.form.value.ehrPrefix,
        password: this.form.value.password
      }).subscribe({
        next: () => {
          this.modalRef.triggerOk();
        },
        error: (error: any) => {
          console.error('Error updating clinic info:', error);
          // Handle error appropriately, e.g., show a notification
        }
      });
    } else {
      this.ehrService.activateEhr({
        password: this.form.value.password,
        hospitalId: this.form.value.hospitalId,
        ehrPrefix: this.form.value.ehrPrefix
      }).subscribe({
        next: () => {
          this.modalRef.triggerOk();
        },
        error: (error: any) => {
          console.error('Error activating EHR:', error);
          // Handle error appropriately, e.g., show a notification
        }
      });
    }
  }
}
